import React, { useState } from 'react';

/**
 * Aviso exibido antes de retirar o aluno da turma (remover, remanejar ou transferir).
 * Os dados do aluno só são consolidados na ficha individual quando os diários
 * dos períodos em que ele estudou são fechados com ele ainda na turma.
 *
 * acao: 'remova' | 'remaneje' | 'transfira'
 */
function Texto({ acao }) {
    return (
        <>
            Verifique se os <strong>diários de todos os períodos</strong> em que o aluno estudou
            {' '}<strong>já foram fechados</strong>. É no fechamento que as notas e a frequência do aluno
            {' '}são <strong>consolidadas nos documentos</strong>.
            <br /><br />
            Se algum período ainda estiver <strong>aberto</strong>: cancele, <strong>feche os diários</strong> dos
            {' '}períodos em que o aluno estudou e <strong>só depois {acao} o aluno</strong>.
        </>
    );
}

/**
 * Janela com fundo desfocado. Abre sozinha ao montar.
 *  - "Continuar": fecha a janela e segue na tela (chama onOk, se houver)
 *  - "Cancelar" : chama onCancel; se não for informado, volta para a tela anterior
 * Pode ser controlada por fora com `open`.
 */
export function ConsolidationWarningModal({ acao = 'retire', open, onOk, onCancel }) {
    const [aberto, setAberto] = useState(true);
    const visivel = open !== undefined ? open : aberto;
    if (!visivel) return null;

    const ok = () => {
        setAberto(false);
        if (onOk) onOk();
    };

    const cancelar = () => {
        setAberto(false);
        if (onCancel) onCancel();
        else window.history.back();
    };

    return (
        <div
            style={{
                position: 'fixed',
                inset: 0,
                zIndex: 3000,
                background: 'rgba(0, 0, 0, 0.45)',
                backdropFilter: 'blur(6px)',
                WebkitBackdropFilter: 'blur(6px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 16,
            }}
        >
            <div
                role="alertdialog"
                aria-modal="true"
                aria-labelledby="consolidation-warning-title"
                style={{
                    width: '100%',
                    maxWidth: 480,
                    maxHeight: '90vh',
                    overflowY: 'auto',
                    boxSizing: 'border-box',
                    background: 'var(--surface, #fff)',
                    color: 'var(--text, #16323b)',
                    borderRadius: 14,
                    borderTop: '6px solid var(--orange, #e67e22)',
                    boxShadow: '0 20px 50px rgba(0, 0, 0, 0.3)',
                    padding: '24px 24px 20px',
                    textAlign: 'left',
                    fontSize: 15,
                    lineHeight: 1.6,
                }}
            >
                <div style={{ fontSize: 40, textAlign: 'center', marginBottom: 6 }}>⚠️</div>
                <h3
                    id="consolidation-warning-title"
                    style={{ margin: '0 0 12px', textAlign: 'center', fontSize: 19, color: 'var(--orange, #d35400)' }}
                >
                    Antes de retirar o aluno da turma
                </h3>
                <p style={{ margin: '0 0 20px' }}>
                    <Texto acao={acao} />
                </p>
                <div style={{ display: 'flex', justifyContent: 'center', gap: 12, flexWrap: 'wrap' }}>
                    <button
                        type="button"
                        onClick={cancelar}
                        style={{
                            minWidth: 140,
                            padding: '12px 24px',
                            border: '1px solid var(--line, #d0d7db)',
                            borderRadius: 10,
                            background: 'transparent',
                            color: 'var(--text, #16323b)',
                            fontSize: 16,
                            fontWeight: 700,
                            cursor: 'pointer',
                        }}
                    >
                        Cancelar
                    </button>
                    <button
                        type="button"
                        onClick={ok}
                        autoFocus
                        style={{
                            minWidth: 140,
                            padding: '12px 24px',
                            border: 'none',
                            borderRadius: 10,
                            background: 'var(--orange, #e67e22)',
                            color: '#fff',
                            fontSize: 16,
                            fontWeight: 800,
                            cursor: 'pointer',
                        }}
                    >
                        Continuar
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ConsolidationWarningModal;
